import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';


const Progressbar = ({onComplete}) => {

    const [showSpinner, setShowSpinner] = useState(true);
    const [progress, setProgress] = useState(0);
    const [progressStatus, setProgressStatus] = useState("모델학습 시작 전");

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(prev => {
                // const nextProgress = prev + 5;
                // 1에서 6까지의 랜덤한 값으로 progress 증가
                const randomIncrement = Math.floor(Math.random() * 6) + 1;
                const nextProgress = prev + randomIncrement;
                if (nextProgress < 12) {
                    setProgressStatus("사전학습된 토크나이저 로드 중...");
                } else if (12 <= nextProgress && nextProgress < 30) {
                    setProgressStatus("모델 맞춤 토큰화 진행 중 ...");
                } else if (30 <= nextProgress && nextProgress < 70) {
                    setProgressStatus("사전학습된 감정분류 모델 로드 중 ...");
                } else if (70 <= nextProgress && nextProgress < 90) {
                    setProgressStatus("전이학습 위한 파라미터 튜닝 중 ...");
                } else if (90 <= nextProgress && nextProgress< 100) {
                    setProgressStatus("최적화된 모델 성능 평가 중 ...");
                } else if (100 <= nextProgress) {
                    setProgressStatus("분류모델 전이학습 완료!");
                }


                if (nextProgress >=100){
                    setShowSpinner(false);
                    if (onComplete) {
                        onComplete(); // 부모 컴포넌트로 완료 이벤트 전달
                    }
                    return 100
                } else {
                    return nextProgress;
                }
                
                
                // return nextProgress >= 100 ? 100 : nextProgress; // 100%를 초과하지 않도록 설정
            });
        }, 1500); // 1.5초마다 업데이트

        return () => clearInterval(interval);
    }, [onComplete]);

    return (
        <div style={{
            width: '800px', marginLeft: '60px', marginRight: '20px',
            display: 'flex', alignItems: 'center'
        }}>
            
            <div style={{ flex: 1, backgroundColor: '#e0e0e0', 
                borderRadius: '8px', overflow: 'hidden' }}>
                <div
                    style={{
                        width: `${progress}%`,
                        height: '20px',
                        backgroundColor: 'rgb(90, 198, 213)',
                        transition: 'width 0.5s ease-in-out',
                    }}
                />
            </div>
            <span
                style={{
                    marginLeft: '30px',
                    marginRight: '10px',
                    color: 'rgb(90, 198, 213)',
                    fontWeight: 'bold',
                }}
            >
                {progress}%
            </span>
            {showSpinner && (
                <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                    size="lg"
                    style={{ margin: '0 20px', color: 'rgb(90, 198, 213)' }}
                />
            )}
            <p className="text-s" style={{marginRight : '20px', marginLeft : '20px', display: 'flex', alignItems: 'center'}}>{progressStatus}</p>
            
        </div>
    );
};

export default Progressbar;
